
// Custom XPath functions need to use the same xpath instance (global or module) as other code
// in the app so that type checks work correctly
const xpath = window.xpath;

const {
    XPathParser,
    XPathContext,
    FunctionResolver,
    Utilities,
    XNodeSet,
    XString,
    XBoolean,
    XNumber,
} = xpath;



// XPathContext, XPathExpression -> XPathResult
export const getParam = (context, expr) =>
    expr.evaluate(context);

// XPathContext, Array[XPathContext, XPathExpression] -> Array[XPathResult]
// The first element of args is the context value so we need to skip that element
export const getParams = (context, [, ...exceptFirst]) =>
    exceptFirst.map((arg) => getParam(context, arg));

// (String, String) -> (thrown error)
export const argError = (fn, expected) => {
    throw new Error(`Function ${fn} expects (${expected || "no arguments"})`);
};

export const emptyXString = new XString('');
export const falseXBoolean = new XBoolean(false);
export const trueXBoolean = new XBoolean(true);



export {
    XPathParser,
    XPathContext,
    FunctionResolver,
    Utilities,
    XNodeSet,
    XString,
    XBoolean,
    XNumber,
};